module.exports = __webpack_public_path__ + "img/sailor-beard-sailing-ship.jpg";